import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import InputGroupWrapper from '@/shared/components/InputGroupWrapper';

const DelayedInput = ({
  value = null,
  type = 'string',
  onChange,
  delay = 500,
  submitOnBlur = true,
  left = null,
  right = null,
  groupTitle = undefined,
  ...rest
}) => {
  const [query, setQuery] = useState(value);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    setQuery(value);
  }, [value]);
  useEffect(() => {
    const id = setTimeout(() => setSaving(true), delay);
    return () => clearTimeout(id);
  }, [query, delay]);

  useEffect(() => {
    if (saving) {
      onChange(query);
      setSaving(false);
    }
    return () => {
      setSaving(false);
    };
  }, [onChange, saving, query]);

  const handleBlur = () => {
    if (!submitOnBlur || saving) return;

    // if (timeoutId) clearTimeout(timeoutId);
    if (value !== query) setSaving(true);
  };

  return (
    <InputGroupWrapper left={left} right={right} title={groupTitle}>
      <input
        {...rest}
        onBlur={handleBlur}
        type={type}
        onChange={e => setQuery(e.target.value)}
        value={query == null ? '' : query}
      />
    </InputGroupWrapper>
  );
};

DelayedInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  submitOnBlur: PropTypes.bool,
  delay: PropTypes.number,
  // Addons rendered before/after the field, e.g. a comparison sign or a unit such as >=
  left: PropTypes.node,
  right: PropTypes.node,
  // Tooltip for the whole group; the addons are covered by it too, unlike a title on the input.
  groupTitle: PropTypes.string,
};
DelayedInput.defaultProps = {
  value: null,
  type: 'string',
  delay: 500,
  submitOnBlur: true,
  left: null,
  right: null,
  groupTitle: undefined,
};
export default DelayedInput;
